import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><title>icon-close</title><path d=\"M410.25 71L249 232.25 87.75 71 69 89.75l161.25 161.254L69 412.25 87.75 431 249 269.75 410.25 431 429 412.25 267.75 251.004 429 89.75z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol